import { createSelector } from 'reselect'

const getLessonsData = state => state.storefront.owner.lessons

const storefrontOwnerLessonsListQuery = createSelector(
	[getLessonsData],
	lessonsData => ({
		page: lessonsData.page,
		more: lessonsData.more,
	})
)

export default storefrontOwnerLessonsListQuery
